<!-- 工厂数据统计 -->
<template>
	<div class="mainContBox flex height-all" :class="{'flex-column': (userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑')}">
		<!-- 产品品质工单率（‰）/破损率工单率（‰） -->
		<div class="flex" :style="{'width': (userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑') ? '100%' : '50%'}">
			<!-- 产品品质工单率（‰） -->
			<div class="statisticsItemWarp" :style="{'width': (userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑') ? '50%' : '100%'}">
				<!-- 顶部搜索模块 -->
				<div class="searchCont factoryDataSearchCont flex-shrink position-relative">
					<baseSearchOs :searchData="productQualitySearchData" @searchClick="productQualitySearchBtnClick" />
				</div>

				<p class="moduleTitle flex align-center">产品品质工单率（‰）</p>
				<div class="statisticsItemEchartsWarp">
					<div class="productQualityEcharts height-all" id="productQualityEcharts"></div>
				</div>
				<!-- 表格数据 -->
				<div class="statisticsItemTable width-screen flex flex-warp">
					<div class="statisticsItemTableTitleRow width-screen flex">
						<p v-for="(item, index) in productQualityDataTitle" :key="index" v-text="item"></p>
					</div>
					<div class="statisticsItemTableContRow width-screen flex" v-for="(item, index) in productQualityDataInfoList" :key="index">
						<p v-text="item.name"></p>
						<p v-text="item.totalTarget"></p>
						<p v-text="item.average"></p>
						<p v-for="(contItem, contIndex) in item.monthValuesList" :key="contIndex" v-text="contItem"></p>
					</div>
				</div>
			</div>

			<!-- 破损率工单率（‰） -->
			<div class="statisticsItemWarp marginRight0" v-if="userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑'">
				<!-- 顶部搜索模块 -->
				<div class="searchCont factoryDataSearchCont flex-shrink position-relative">
					<baseSearchOs :searchData="productDamageRateSearchData" @searchClick="productDamageRateSearchBtnClick" />
				</div>

				<p class="moduleTitle flex align-center">破损率工单率（‰）</p>
				<div class="statisticsItemEchartsWarp">
					<div class="productDamageRateEcharts height-all" id="productDamageRateEcharts">

					</div>
				</div>
				<!-- 表格数据 -->
				<div class="statisticsItemTable width-screen flex flex-warp">
					<div class="statisticsItemTableTitleRow width-screen flex">
						<p v-for="(item, index) in productDamageRateDataTitle" :key="index" v-text="item"></p>
					</div>
					<div class="statisticsItemTableContRow width-screen flex" v-for="(item, index) in productDamageRateDataInfoList" :key="index">
						<p v-text="item.name"></p>
						<p v-text="item.totalTarget"></p>
						<p v-text="item.average"></p>
						<p v-for="(contItem, contIndex) in item.monthValuesList" :key="contIndex" v-text="contItem"></p>
					</div>
				</div>
			</div>
		</div>

		<!-- 生产发货时效（天） -->
		<div class="flex" :style="{'width': (userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑') ? '100%' : '50%'}">
			<!-- 生产发货时效（天） -->
			<div class="statisticsItemWarp statisticsItemWarp100">
				<!-- 顶部搜索模块 -->
				<div class="searchCont deliveryTimeSearchCont flex-shrink position-relative">
					<baseSearchOs :searchData="deliveryTimeSearchData" @searchClick="deliveryTimeSearchBtnClick" />
				</div>

				<p class="moduleTitle flex align-center">生产发货时效（天）</p>
				<div class="statisticsItemEchartsWarp flex">
					<div class="deliveryTimeEcharts height-all" id="deliveryTimeLeftEcharts">

					</div>
					<template v-if="userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑'">
						<div class="deliveryTimeEcharts height-all" id="deliveryTimeRightEcharts">
						
						</div>
					</template>
				</div>

				<!-- 表格数据 -->
				<div class="statisticsItemTable width-screen flex flex-warp">
					<div class="statisticsItemTableTitleRow width-screen flex">
						<p v-for="(item, index) in deliveryTimeDataTitle" :key="index" v-text="item"></p>
					</div>
					<div class="statisticsItemTableContRow width-screen flex" v-for="(item, index) in deliveryTimeDataInfoList" :key="index">
						<p v-text="item.name"></p>
						<p v-text="item.totalTarget"></p>
						<p v-text="item.average"></p>
						<p v-for="(contItem, contIndex) in item.monthValuesList" :key="contIndex" v-text="contItem"></p>
					</div>
				</div>
			</div>
		</div>

		<!-- 新天下/昆仑---错发率（‰）/新天下/昆仑---墨渍率（‰） -->
		<template v-if="userInfo.productCompanyName == '新天下' || userInfo.productCompanyName == '昆仑'">
			<div class="width-screen flex">
				<!-- 新天下/昆仑---错发率（‰） -->
				<div class="statisticsItemWarp marginBottom0">
					<!-- 顶部搜索模块 -->
					<div class="searchCont factoryDataSearchCont flex-shrink position-relative">
						<baseSearchOs :searchData="errorRateSearchData" @searchClick="errorRateSearchBtnClick" />
					</div>
			
					<p class="moduleTitle flex align-center" v-text="userInfo.productCompanyName + '---错发率（‰）'"></p>
					<div class="statisticsItemEchartsWarp">
						<div class="productQualityEcharts height-all" id="errorRateEcharts">
			
						</div>
					</div>
					<!-- 表格数据 -->
					<div class="statisticsItemTable width-screen flex flex-warp">
						<div class="statisticsItemTableTitleRow width-screen flex">
							<p v-for="(item, index) in errorRateDataTitle" :key="index" v-text="item"></p>
						</div>
						<div class="statisticsItemTableContRow width-screen flex" v-for="(item, index) in errorRateDataInfoList" :key="index">
							<p v-text="item.name"></p>
							<p v-text="item.totalTarget"></p>
							<p v-text="item.average"></p>
							<p v-for="(contItem, contIndex) in item.monthValuesList" :key="contIndex" v-text="contItem"></p>
						</div>
					</div>
				</div>
			
				<!-- 新天下/昆仑---墨渍率（‰） -->
				<div class="statisticsItemWarp marginRight0 marginBottom0">
					<!-- 顶部搜索模块 -->
					<div class="searchCont factoryDataSearchCont flex-shrink position-relative">
						<baseSearchOs :searchData="inkStainRateSearchData" @searchClick="inkStainRateSearchBtnClick" />
					</div>
			
					<p class="moduleTitle flex align-center" v-text="userInfo.productCompanyName + '---墨渍率（‰）'"></p>
					<div class="statisticsItemEchartsWarp">
						<div class="productDamageRateEcharts height-all" id="inkStainRateEcharts">
			
						</div>
					</div>
					<!-- 表格数据 -->
					<div class="statisticsItemTable width-screen flex flex-warp">
						<div class="statisticsItemTableTitleRow width-screen flex">
							<p v-for="(item, index) in inkStainRateDataTitle" :key="index" v-text="item"></p>
						</div>
						<div class="statisticsItemTableContRow width-screen flex" v-for="(item, index) in inkStainRateDataInfoList" :key="index">
							<p v-text="item.name"></p>
							<p v-text="item.totalTarget"></p>
							<p v-text="item.average"></p>
							<p v-for="(contItem, contIndex) in item.monthValuesList" :key="contIndex" v-text="contItem"></p>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import baseSearchOs from "@/components/baseSearchOs";
	export default {
		name: 'factoryDataStatistics',
		inject: ['$http', '$api', '$utils', '$userUtils'],
		components: {
			baseSearchOs
		},
		data() {
			return {
				productQualitySearchData: [{
					label: "支付时间",
					type: "monthrange",
					name: "searchTime",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM',
					restrict: true,
					NoClearable: true
				}, {
					label: "统计维度",
					type: "select",
					name: "latitude",
					value: "order",
					options: [{
						label: '订单量',
						value: "order"
					}, {
						label: '产品量',
						value: "work"
					}],
					isHaveStar: true,
					NoClearable: true,
				}], //产品品质工单率搜索数据
				productQualitySearchDataParam: {
					startTime: "",
					endTime: "",
					latitude: "order"
				},
				productQualityData: {},
				productQualityDataInfoList: [],  //表格数据
				productQualityDataTitle: [],  //标题

				productDamageRateSearchData: [{
					label: "支付时间",
					type: "monthrange",
					name: "searchTime",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM',
					restrict: true,
					NoClearable: true,
				}, {
					label: "统计维度",
					type: "select",
					name: "latitude",
					value: "order",
					options: [{
						label: '订单量',
						value: "order"
					}, {
						label: '产品量',
						value: "work"
					}],
					isHaveStar: true,
					NoClearable: true,
				}], //破损率工单率搜索数据
				productDamageRateSearchDataParam: {
					startTime: "",
					endTime: "",
					latitude: "order"
				},
				productDamageRateData: {},
				productDamageRateDataInfoList: [],  //表格数据
				productDamageRateDataTitle: [],  //标题
				

				deliveryTimeSearchData: [{
					label: "支付时间",
					type: "monthrange",
					name: "searchTime",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM',
					restrict: true,
					NoClearable: true,
				}], //生产发货时效搜索数据
				deliveryTimeSearchDataParam: {
					startTime: "",
					endTime: ""
				},
				deliveryTimeData: {},
				deliveryTimeDataInfoList: [],  //表格数据
				deliveryTimeDataTitle: [],  //标题

				errorRateSearchData: [{
					label: "支付时间",
					type: "monthrange",
					name: "searchTime",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM',
					restrict: true,
					NoClearable: true,
				}, {
					label: "统计维度",
					type: "select",
					name: "latitude",
					value: "order",
					options: [{
						label: '订单量',
						value: "order"
					}, {
						label: '产品量',
						value: "work"
					}],
					isHaveStar: true,
					NoClearable: true,
				}], //错发率搜索数据
				errorRateSearchDataParam: {
					startTime: "",
					endTime: "",
					latitude: "order"
				},
				errorRateData: {},
				errorRateDataInfoList: [],  //表格数据
				errorRateDataTitle: [],  //标题

				inkStainRateSearchData: [{
					label: "支付时间",
					type: "monthrange",
					name: "searchTime",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM',
					restrict: true,
					NoClearable: true,
				}, {
					label: "统计维度",
					type: "select",
					name: "latitude",
					value: "order",
					options: [{
						label: '订单量',
						value: "order"
					}, {
						label: '产品量',
						value: "work"
					}],
					isHaveStar: true,
					NoClearable: true,
				}], //墨渍率搜索数据
				inkStainRateSearchDataParam: {
					startTime: "",
					endTime: "",
					latitude: "order"
				},
				inkStainRateData: {},
				inkStainRateDataInfoList: [],  //表格数据
				inkStainRateDataTitle: [],  //标题
				userInfo: {},  //用户信息
			}
		},
		mounted() {
			let that = this;
			//获取当前登录者用户信息
			that.userInfo = that.$userUtils.getUserInfo();
			
			//初始化时间【延迟0.5秒后初始化时间，防止新天下和昆仑登录时，页面组件未加载完成】
			setTimeout(function() {
				that.initTime();
			}, 500)
		},
		methods: {
			/**
			 * 初始化搜索时间
			 */
			initTime() {
				//默认6个月
				const end = this.$utils.getDateTime(this.$utils.getTimeStamp(), ['y', 'm']);
				const start = this.$utils.getDateTime((this.$utils.getTimeStamp() - 3600 * 1000 * 24 * 31 * 6), ['y', 'm']);
				console.log("end:::", end, "   start:::", start);
				
				//默认产品品质工单率搜索时间
				this.productQualitySearchData[0].value = [start, end]
				this.productQualitySearchDataParam.startTime = start;
				this.productQualitySearchDataParam.endTime = end;
				//产品品质工单率汇总统计
				this.getProductQualityWorkOrderRate();
				
				//默认破损率工单率搜索时间
				this.productDamageRateSearchData[0].value = [start, end]
				this.productDamageRateSearchDataParam.startTime = start;
				this.productDamageRateSearchDataParam.endTime = end;
				//工厂破损率汇总统计
				this.getWorkOrderDamagedRete();
				
				//默认生产发货时效搜索时间
				this.deliveryTimeSearchData[0].value = [start, end]
				this.deliveryTimeSearchDataParam.startTime = start;
				this.deliveryTimeSearchDataParam.endTime = end;
				//生产发货时效汇总统计
				this.getProductDeliveryTimes();
				this.getSecondProductDeliveryTimesCharts();
				
				//默认新天下/昆仑---错发率搜索时间
				this.errorRateSearchData[0].value = [start, end]
				this.errorRateSearchDataParam.startTime = start;
				this.errorRateSearchDataParam.endTime = end;
				//生产商工单错发率
				this.getWorkOrderWrongIssuanceRete();
				
				//默认新天下/昆仑---墨渍率搜索时间
				this.inkStainRateSearchData[0].value = [start, end]
				this.inkStainRateSearchDataParam.startTime = start;
				this.inkStainRateSearchDataParam.endTime = end;
				//生产商工单墨渍率
				this.getWorkOrderInkStainRete();
			},
			/**
			 * 生产商工单墨渍率
			 */
			getWorkOrderInkStainRete() {
				let that = this;
				
				that.$http.post(that.$api.getWorkOrderInkStainReteApi, that.inkStainRateSearchDataParam).then(res=>{
					if(res.code == 200) {
						that.inkStainRateData = res.data;
						that.inkStainRateDataInfoList = res.data.dataInfoList;
						
						//追加标题
						that.inkStainRateDataTitle = ["产品", "总目标", "均值"];
						if(that.inkStainRateData.monthInfo.length > 0) {
							that.inkStainRateData.monthInfo.forEach((item, index) => {
								that.inkStainRateDataTitle.push(item);
							})
						}
						
						//初始化图表
						if(!that.$utils.isEmpty(that.inkStainRateData.chartInfo)) {
							that.initProductQualityEchartsLine("inkStainRate", that.inkStainRateData.chartInfo);
						}
					}
				})
			},
			/**
			 * 生产商工单错发率
			 */
			getWorkOrderWrongIssuanceRete() {
				let that = this;
				
				that.$http.post(that.$api.getWorkOrderWrongIssuanceReteApi, that.errorRateSearchDataParam).then(res=>{
					if(res.code == 200) {
						that.errorRateData = res.data;
						that.errorRateDataInfoList = res.data.dataInfoList;
						
						//追加标题
						that.errorRateDataTitle = ["产品", "总目标", "均值"];
						if(that.errorRateData.monthInfo.length > 0) {
							that.errorRateData.monthInfo.forEach((item, index) => {
								that.errorRateDataTitle.push(item);
							})
						}
						
						//初始化图表
						if(!that.$utils.isEmpty(that.errorRateData.chartInfo)) {
							that.initProductQualityEchartsLine("errorRate", that.errorRateData.chartInfo);
						}
					}
				})
			},
			/**
			 * 生产发货时效汇总统计(仅精装照片书、桌摆)
			 */
			getSecondProductDeliveryTimesCharts() {
				let that = this;
				
				that.$http.post(that.$api.getSecondProductDeliveryTimesChartsApi, that.deliveryTimeSearchDataParam).then(res=>{
					if(res.code == 200) {						
						//初始化图表
						if(!that.$utils.isEmpty(res.data)) {
							that.initProductQualityEchartsLine("deliveryTimeRight", res.data);
						}
					}
				})
			},
			/**
			 * 生产发货时效汇总统计
			 */
			getProductDeliveryTimes() {
				let that = this;
				
				that.$http.post(that.$api.getProductDeliveryTimesApi, that.deliveryTimeSearchDataParam).then(res=>{
					if(res.code == 200) {
						that.deliveryTimeData = res.data;
						that.deliveryTimeDataInfoList = res.data.dataInfoList;
						
						//追加标题
						that.deliveryTimeDataTitle = ["产品", "总目标", "均值"];
						if(that.deliveryTimeData.monthInfo.length > 0) {
							that.deliveryTimeData.monthInfo.forEach((item, index) => {
								that.deliveryTimeDataTitle.push(item);
							})
						}
						
						//初始化图表
						if(!that.$utils.isEmpty(that.deliveryTimeData.chartInfo)) {
							that.initProductQualityEchartsLine("deliveryTime", that.deliveryTimeData.chartInfo);
						}
					}
				})
			},
			/**
			 * 工厂破损率汇总统计
			 */
			getWorkOrderDamagedRete() {
				let that = this;
				
				that.$http.post(that.$api.getWorkOrderDamagedReteApi, that.productDamageRateSearchDataParam).then(res=>{
					if(res.code == 200) {
						that.productDamageRateData = res.data;
						that.productDamageRateDataInfoList = res.data.dataInfoList;
						
						//追加标题
						that.productDamageRateDataTitle = ["产品", "总目标", "均值"];
						if(that.productDamageRateData.monthInfo.length > 0) {
							that.productDamageRateData.monthInfo.forEach((item, index) => {
								that.productDamageRateDataTitle.push(item);
							})
						}
						
						//初始化图表
						if(!that.$utils.isEmpty(that.productDamageRateData.chartInfo)) {
							that.initProductQualityEchartsLine("productDamageRate", that.productDamageRateData.chartInfo);
						}
					}
				})
			},
			/**
			 * 产品品质工单率汇总统计
			 */
			getProductQualityWorkOrderRate() {
				let that = this;
				
				that.$http.post(that.$api.getProductQualityWorkOrderRateApi, that.productQualitySearchDataParam).then(res=>{
					if(res.code == 200) {
						that.productQualityData = res.data;
						that.productQualityDataInfoList = res.data.dataInfoList;
						
						//追加标题
						that.productQualityDataTitle = ["产品", "总目标", "均值"];
						if(that.productQualityData.monthInfo.length > 0) {
							that.productQualityData.monthInfo.forEach((item, index) => {
								that.productQualityDataTitle.push(item);
							})
						}
						
						//初始化图表
						if(!that.$utils.isEmpty(that.productQualityData.chartInfo)) {
							that.initProductQualityEchartsLine("productQuality", that.productQualityData.chartInfo);
						}
					}
				})
			},
			/**
			 * 产品品质工单率折线图
			 * @param {Object} type 图表标识【productQuality：产品品质工单率   productDamageRate：工厂破损率汇总统计   deliveryTime：生产发货时效汇总】
			 * @param {object} echartsData 图表数据
			 */
			initProductQualityEchartsLine(type, echartsData) {
				let that = this;
				let tooltipTitle = "";
				let seriesData = [];
				let legendData = [];
				let xData = [];
				let unit = "";
				
				let markLineData = {};
				if(type == "productDamageRate"){
					markLineData = {
						data: [
							{ yAxis: '1' } // 例如：yAxis: '1000'
						],
						label: {
							show: true,
							position: "start",
							color: "#f00",
							formatter: function (params) {
								return params.value + '‰'; // 显示yAxis指定的值
							}
						},
						lineStyle: {
							color: 'red', // 线的颜色
							type: 'solid'// 线的类型，例如：'solid', 'dotted', 'dashed'
						}
					}
				}else{
					markLineData = {
						data: [{
							type: 'average',
							name: 'Avg'
						}]
					}
				}
				if(echartsData.series.length > 0) {
					echartsData.series.forEach((item, index) => {
						let seriesDataItem = {
							name: item.name,
							type: item.type,
							data: item.data,
							smooth: true,
							markLine: markLineData
						}
						
						seriesData.push(seriesDataItem);
						legendData.push(item.name);
					})
				}
				
				//根据图表标识，区分标题
				if(type == "productQuality") {
					tooltipTitle = "产品品质工单率：";
					unit = "‰";
					xData = that.productQualityData.chartInfo.xData;
				}else if(type == "productDamageRate") {
					tooltipTitle = "破损率工单率：";
					unit = "‰";
					xData = that.productDamageRateData.chartInfo.xData;
				}else if(type == "deliveryTime") {
					tooltipTitle = "生产发货时效：";
					unit = "天";
					xData = that.deliveryTimeData.chartInfo.xData;
				}else if(type == "deliveryTimeRight") {
					tooltipTitle = "生产发货时效：";
					unit = "天";
					xData = echartsData.xData;
				}else if(type == "errorRate") {
					tooltipTitle = "错发率：";
					unit = "‰";
					xData = that.errorRateData.chartInfo.xData;
				}else if(type == "inkStainRate") {
					tooltipTitle = "墨渍率：";
					unit = "‰";
					xData = that.inkStainRateData.chartInfo.xData;
				}
				
				let polygonData = {
					color: ["#FF7CCF", "#FFDD00", "#5087EC"],
					legend: {
						data: legendData,
						top: "top",
						right: "5%"
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							let result = "";
							if (params.length > 0) {
								result += tooltipTitle;
								params.forEach((item, index) => {
									result += `<div>${item.seriesName}：${item.data}${unit}</div>`;
								})
							}
							return result;
						},
						axisPointer: {
							z: 0,
							lineStyle: {
								type: 'dashed',
								color: '#DEE6ED'
							}
						},
						backgroundColor: 'rgba(255, 255, 255, 1)',
						textStyle: {
							color: '#666666',
							fontSize: 12,
						},
						extraCssText: 'box-shadow: 0 2px 15px 1px rgba(0, 0, 0, 0.35);'
					},
					grid: {
						top: '15%',
						right: '40px',
						bottom: '10%',
						left: "60px"
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: xData
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value} ' + unit
						}
					},
					series: seriesData
				};
				
				let showOrderTrendChart = "";
				if(type == "productQuality") {
					showOrderTrendChart = echarts.init(document.getElementById('productQualityEcharts'));
				}else if(type == "productDamageRate") {
					showOrderTrendChart = echarts.init(document.getElementById('productDamageRateEcharts'));
				}else if(type == "deliveryTime") {
					showOrderTrendChart = echarts.init(document.getElementById('deliveryTimeLeftEcharts'));
				}else if(type == "deliveryTimeRight") {
					showOrderTrendChart = echarts.init(document.getElementById('deliveryTimeRightEcharts'));
				}else if(type == "errorRate") {
					showOrderTrendChart = echarts.init(document.getElementById('errorRateEcharts'));
				}else if(type == "inkStainRate") {
					showOrderTrendChart = echarts.init(document.getElementById('inkStainRateEcharts'));
				}
				
				showOrderTrendChart.setOption(polygonData, true);
			},
			/**
			 * 产品品质工单率 搜索 按钮点击事件
			 */
			productQualitySearchBtnClick(option) {
				let that = this;
				that.productQualitySearchDataParam = Object.assign(that.productQualitySearchDataParam, option);
				
				if (that.$utils.isEmpty(option.searchTime)) {
					that.$message.warning('请选择支付时间');
					return;
				} else {
					const searchTimeStart = that.$utils.changeTimestamp(option.searchTime[0])
					const searchTimeEnd = that.$utils.changeTimestamp(option.searchTime[1])
					console.log(searchTimeEnd - searchTimeStart)
					
					//最长筛选12个月，每个月按照30天计算
					if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 30 * 12) {
						that.productQualitySearchDataParam.startTime = option.searchTime[0];
						that.productQualitySearchDataParam.endTime = option.searchTime[1];
						
						//初始化数据
						that.getProductQualityWorkOrderRate();
					} else {
						that.$message.warning("筛选时间不得大于12个月");
						return;
					}
				}
			},
			/**
			 * 破损率工单率 搜索 按钮点击事件
			 */
			productDamageRateSearchBtnClick(option) {
				let that = this;
				that.productDamageRateSearchDataParam = Object.assign(that.productDamageRateSearchDataParam, option);
				
				if (that.$utils.isEmpty(option.searchTime)) {
					that.$message.warning('请选择支付时间');
					return;
				} else {
					const searchTimeStart = that.$utils.changeTimestamp(option.searchTime[0])
					const searchTimeEnd = that.$utils.changeTimestamp(option.searchTime[1])
					console.log(searchTimeEnd - searchTimeStart)
					
					//最长筛选12个月，每个月按照30天计算
					if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 30 * 12) {
						that.productDamageRateSearchDataParam.startTime = option.searchTime[0];
						that.productDamageRateSearchDataParam.endTime = option.searchTime[1];
						
						//初始化数据
						that.getWorkOrderDamagedRete();
					} else {
						that.$message.warning("筛选时间不得大于12个月");
						return;
					}
				}
			},
			/**
			 * 生产发货时效 搜索 按钮点击事件
			 */
			deliveryTimeSearchBtnClick(option) {
				let that = this;
				that.deliveryTimeSearchDataParam = Object.assign(that.deliveryTimeSearchDataParam, option);
				
				if (that.$utils.isEmpty(option.searchTime)) {
					that.$message.warning('请选择支付时间');
					return;
				} else {
					const searchTimeStart = that.$utils.changeTimestamp(option.searchTime[0])
					const searchTimeEnd = that.$utils.changeTimestamp(option.searchTime[1])
					console.log(searchTimeEnd - searchTimeStart)
					
					//最长筛选12个月，每个月按照30天计算
					if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 30 * 12) {
						that.deliveryTimeSearchDataParam.startTime = option.searchTime[0];
						that.deliveryTimeSearchDataParam.endTime = option.searchTime[1];
						
						//初始化数据
						that.getProductDeliveryTimes();
						that.getSecondProductDeliveryTimesCharts();
					} else {
						that.$message.warning("筛选时间不得大于12个月");
						return;
					}
				}
			},
			/**
			 * 错发率 搜索 按钮点击事件
			 */
			errorRateSearchBtnClick(option) {
				let that = this;
				that.errorRateSearchDataParam = Object.assign(that.errorRateSearchDataParam, option);
				
				if (that.$utils.isEmpty(option.searchTime)) {
					that.$message.warning('请选择支付时间');
					return;
				} else {
					const searchTimeStart = that.$utils.changeTimestamp(option.searchTime[0])
					const searchTimeEnd = that.$utils.changeTimestamp(option.searchTime[1])
					console.log(searchTimeEnd - searchTimeStart)
					
					//最长筛选12个月，每个月按照30天计算
					if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 30 * 12) {
						that.errorRateSearchDataParam.startTime = option.searchTime[0];
						that.errorRateSearchDataParam.endTime = option.searchTime[1];
						
						//初始化数据
						that.getWorkOrderWrongIssuanceRete();
					} else {
						that.$message.warning("筛选时间不得大于12个月");
						return;
					}
				}
			},
			/**
			 * 墨渍率 搜索 按钮点击事件
			 */
			inkStainRateSearchBtnClick(option) {
				let that = this;
				that.inkStainRateSearchDataParam = Object.assign(that.inkStainRateSearchDataParam, option);
				
				if (that.$utils.isEmpty(option.searchTime)) {
					that.$message.warning('请选择支付时间');
					return;
				} else {
					const searchTimeStart = that.$utils.changeTimestamp(option.searchTime[0])
					const searchTimeEnd = that.$utils.changeTimestamp(option.searchTime[1])
					console.log(searchTimeEnd - searchTimeStart)
					
					//最长筛选12个月，每个月按照30天计算
					if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 30 * 12) {
						that.inkStainRateSearchDataParam.startTime = option.searchTime[0];
						that.inkStainRateSearchDataParam.endTime = option.searchTime[1];
						
						//初始化数据
						that.getWorkOrderInkStainRete();
					} else {
						that.$message.warning("筛选时间不得大于12个月");
						return;
					}
				}
			}
		},
	}
</script>

<style>
	.statisticsItemWarp {
		padding: 16px;
		box-sizing: border-box;
		border-radius: 8px;
		background: #fff;
		width: 50%;
		margin-right: 16px;
		margin-bottom: 16px;
	}

	.marginBottom0 {
		margin-bottom: 0;
	}

	.statisticsItemWarp100 {
		width: 100%;
		margin-right: 0;
	}

	.marginRight0 {
		margin-right: 0;
	}

	.moduleTitle {
		font-size: 16px;
		color: #333333;
		font-weight: 600;
		line-height: 25px;
		margin-bottom: 16px;
	}

	.statisticsItemEchartsWarp {
		height: 350px;
	}

	.deliveryTimeEcharts {
		flex: 1;
	}

	.statisticsItemTable {
		overflow: auto;
		margin-top: 16px;
	}

	.statisticsItemTableTitleRow {
		background: #F3F4F5;
	}

	.statisticsItemTableTitleRow p:not(:nth-child(1)),
	.statisticsItemTableContRow p:not(:nth-child(1)) {
		font-size: 12px;
		font-weight: 600;
		color: #333333;
		text-align: center;
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #F3F4F5;
		border-right: 1px solid #F3F4F5;
		box-sizing: border-box;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		flex: 1;
	}

	.statisticsItemTableTitleRow p:nth-child(1),
	.statisticsItemTableContRow p:nth-child(1) {
		width: 70px;
		font-size: 12px;
		font-weight: 600;
		color: #333333;
		text-align: center;
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #F3F4F5;
		box-sizing: border-box;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.statisticsItemTableContRow p {
		font-weight: normal !important;
	}

	.statisticsItemTableContRow p:nth-child(1) {
		font-weight: 600 !important;
		background: #F3F4F5;
	}


	.factoryDataSearchCont .searchItemDiv {
		margin: 0 !important;
		width: 27% !important;
		margin-right: 5px !important;
		min-width: auto;
	}

	.deliveryTimeSearchCont .searchItemDiv {
		margin: 0 !important;
		margin-right: 5px !important;
	}

	.factoryDataSearchCont .widthLong {
		width: 45% !important;
	}
	
	.factoryDataSearchCont .searchItemInput{
		width: 56%;
	}

	.factoryDataSearchCont .searchBtn {
		margin: 0 !important;
	}

	.mainContBox {
		overflow-y: scroll !important;
	}
</style>
<style scoped>
	.searchCont {
		padding: 0;
		background-color: #ffffff;
		border-radius: 10px;
		margin-bottom: 16px;
	}
	.mainContBox{
		padding-top: 0 !important;
	}
</style>